module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-02.d81a393b.jpg";